define([
	'internal_util/Util',
	'view/UIView',
	'amdi18n-loader?!view/nls/RecoveryStrategyView_strings',
	'lib/jquery'
], function (
		Util,
		UIView,
		Strings,
		jQuery
		) {
	'use strict';

	/**
	 * RecoveryStrategyView class
	 */
	function RecoveryStrategyView(recoveryStrategyCallbacks) {
		var _recoveryStrategyCallbacks = recoveryStrategyCallbacks,
				_view = jQuery("<div id='skIdS_recoverystrategy-selection-container' class='skIdS_content-body'></div>");

		UIView.call(this);


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (recoveryStrategies) {
			var $entry,
					i;

			if (!Util.isArray(recoveryStrategies)) {
				throw new Error('invalid recoveryStrategies');
			}

			_view.empty();

			$entry = jQuery('<div class="skIdS_recoverystrategy-selection-entry">' +
					'<span>' + Strings.download_eid_client + '</span>' +
					'</div>');

			_view.append($entry);

			for (i = 0; i < recoveryStrategies.length; i++) {
				$entry = jQuery('<div class="skIdS_recoverystrategy-selection-entry">' +
						'<img align="left" src="' + recoveryStrategies[i].icon().url() + '" />' +
						(recoveryStrategies[i].description() !== undefined ?
								'<span class="desc">' + recoveryStrategies[i].description() + '</span>' : '') +
						'</div>');

				if (typeof _recoveryStrategyCallbacks !== 'undefined') {
					$entry.find("img").on('click', (function (recoveryStrategy) {
						return function () {
							Util.callCallbacks(_recoveryStrategyCallbacks, recoveryStrategy)
						};
					})(recoveryStrategies[i]));
				}

				_view.append($entry);
			}
		};
	}

	RecoveryStrategyView.prototype = Object.create(UIView.prototype);

	return RecoveryStrategyView;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/RecoveryStrategyView.js
// module id = 163
// module chunks = 1